import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "customer-picker-body"
};
const _hoisted_2 = {
  key: 0,
  class: "customer-selected-panel"
};
const _hoisted_3 = {
  class: "customer-selected-header"
};
const _hoisted_4 = {
  class: "customer-selected-title"
};
const _hoisted_5 = {
  class: "customer-selected-list"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  class: "customer-chip-avatar"
};
const _hoisted_8 = {
  class: "customer-chip-name"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "customer-search"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "customer-row-main"
};
const _hoisted_13 = {
  class: "customer-avatar"
};
const _hoisted_14 = {
  class: "customer-avatar-char"
};
const _hoisted_15 = {
  class: "customer-meta"
};
const _hoisted_16 = {
  class: "customer-name"
};
const _hoisted_17 = {
  key: 0,
  class: "customer-sub"
};
const _hoisted_18 = {
  key: 1,
  class: "customer-sub"
};
const _hoisted_19 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
};
const _hoisted_20 = {
  key: 0,
  class: "load-hint"
};
const _hoisted_21 = {
  key: 1,
  class: "load-hint"
};
const _hoisted_22 = {
  class: "customer-picker-footer"
};
const _hoisted_23 = {
  class: "customer-footer-info"
};
const _hoisted_24 = {
  class: "customer-footer-actions"
};
import { ref, reactive, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { Search } from '@element-plus/icons-vue';
import { useVModel } from '@vueuse/core';
import { getCustomerPage, getCustomer } from '@/api/customer';
export default {
  __name: 'CustomerPicker',
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxSelect: {
      type: Number,
      default: null
    },
    excludeIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    const value = useVModel($props, 'modelValue', $emits);
    const customerOptions = ref([]);
    const customerList = ref([]);
    const loading = ref(false);
    const scrollbarRef = ref();
    const hasMore = ref(true);
    const pagination = reactive({
      page: 1,
      size: 10,
      total: 0
    });
    const toCustomerOption = customer => {
      const data = customer?.data || customer || {};
      const companies = Array.isArray(data.companies) ? data.companies : [];
      return {
        id: data.id,
        name: data.name || `客户${data.id}`,
        phone: data.phone || '',
        customerNo: data.customerNo || '',
        companyName: companies.map(c => c?.companyName).filter(Boolean).join('、')
      };
    };
    const isSelected = customer => {
      return customerOptions.value.some(e => String(e.id) === String(customer.id));
    };
    const onCustomerClick = data => {
      if ($props.multiple) {
        const index = customerOptions.value.findIndex(e => String(e.id) === String(data.id));
        if (index === -1) {
          if ($props.maxSelect && customerOptions.value.length >= $props.maxSelect) {
            ElMessage.warning(`最多选择${$props.maxSelect}个客户`);
            return;
          }
          customerOptions.value.push(data);
          customerOptions.value.sort((a, b) => String(a.id).localeCompare(String(b.id)));
        } else {
          customerOptions.value.splice(index, 1);
        }
      } else {
        const index = customerOptions.value.findIndex(e => String(e.id) === String(data.id));
        if (index === -1) {
          customerOptions.value = [data];
        } else {
          customerOptions.value.splice(index, 1);
        }
      }
    };
    const dialogVisible = ref(false);
    const queryForm = reactive({
      keyword: ''
    });
    const open = () => {
      dialogVisible.value = true;
    };
    const fetchCustomers = async ({
      append = false
    } = {}) => {
      if (loading.value) return;
      loading.value = true;
      try {
        const keyword = queryForm.keyword?.trim();
        const res = await getCustomerPage({
          page: pagination.page,
          size: pagination.size,
          keyword: keyword || undefined
        });
        const records = res?.records || [];
        const nextCustomers = records.map(toCustomerOption);
        if (append) {
          const exists = new Set(customerList.value.map(c => String(c.id)));
          customerList.value = customerList.value.concat(nextCustomers.filter(c => !exists.has(String(c.id))));
        } else {
          customerList.value = nextCustomers;
        }
        pagination.total = Number(res?.total ?? records.length);
        hasMore.value = pagination.total > 0 ? customerList.value.length < pagination.total : records.length === pagination.size;
      } finally {
        loading.value = false;
      }
    };
    const loadSelectedCustomers = async () => {
      // 处理已选中的客户ID，查找并填充客户信息
      let customerIds = [];
      if (Array.isArray(value.value)) {
        customerIds.push(...value.value);
      } else if (value.value) {
        customerIds.push(value.value);
      }
      if (customerIds.length > 0) {
        const selected = await Promise.all(customerIds.map(async id => {
          const currentPageCustomer = customerList.value.find(c => String(c.id) === String(id));
          if (currentPageCustomer) return {
            ...currentPageCustomer
          };
          try {
            return toCustomerOption(await getCustomer(id));
          } catch (error) {
            console.error('加载客户信息失败:', error);
            return {
              id,
              name: String(id),
              phone: '',
              customerNo: ''
            };
          }
        }));
        customerOptions.value = selected.filter(c => c.id);
      } else {
        customerOptions.value = [];
      }
    };
    const onOpen = async () => {
      pagination.page = 1;
      hasMore.value = true;
      customerList.value = [];
      await fetchCustomers();
      await loadSelectedCustomers();
    };
    const handleSearch = () => {
      pagination.page = 1;
      hasMore.value = true;
      customerList.value = [];
      fetchCustomers();
    };
    const excludeIdSet = computed(() => new Set(($props.excludeIds || []).map(id => String(id))));
    const visibleCustomerList = computed(() => customerList.value.filter(c => !excludeIdSet.value.has(String(c.id))));
    const loadNextPage = () => {
      if (loading.value || !hasMore.value) return;
      pagination.page += 1;
      fetchCustomers({
        append: true
      });
    };
    const handleScroll = ({
      scrollTop
    }) => {
      const wrap = scrollbarRef.value?.wrapRef;
      if (!wrap) return;
      const distanceToBottom = wrap.scrollHeight - wrap.clientHeight - scrollTop;
      if (distanceToBottom <= 24) {
        loadNextPage();
      }
    };
    const handleConfirm = () => {
      if ($props.multiple) {
        value.value = customerOptions.value.map(e => e.id);
      } else {
        if (customerOptions.value.length > 0) {
          value.value = customerOptions.value[0].id;
        } else {
          value.value = null;
        }
      }
      $emits('confirm', customerOptions.value.map(c => ({
        id: c.id,
        name: c.name,
        phone: c.phone,
        customerNo: c.customerNo
      })));
      dialogVisible.value = false;
    };
    const clearSelected = () => {
      customerOptions.value = [];
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onOpen: onOpen,
        "modal-class": "customer-picker-overlay",
        title: __props.multiple ? `选择客户（已选 ${customerOptions.value.length}${__props.maxSelect ? '/' + __props.maxSelect : ''}）` : '选择客户',
        width: "460px",
        class: "customer-picker-dialog",
        "append-to-body": "",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [__props.multiple ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_cache[6] || (_cache[6] = _createTextVNode("已选 ", -1)), _createElementVNode("em", null, _toDisplayString(customerOptions.value.length), 1), _cache[7] || (_cache[7] = _createTextVNode(" 个客户", -1))], 64)) : customerOptions.value.length === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode("已选 " + _toDisplayString(customerOptions.value[0]?.name), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode("未选择")], 64))]), _createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleConfirm
        }, "确认")])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.multiple && customerOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_cache[3] || (_cache[3] = _createTextVNode("已选 ", -1)), _createElementVNode("em", null, _toDisplayString(customerOptions.value.length), 1), _createTextVNode(_toDisplayString(__props.maxSelect ? ` / ${__props.maxSelect}` : ''), 1)]), customerOptions.value.length > 0 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "customer-selected-clear",
          onClick: clearSelected
        }, "清空")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerOptions.value, customer => {
          return _openBlock(), _createElementBlock("span", {
            key: customer.id,
            class: "customer-chip",
            title: customer.name
          }, [_createElementVNode("span", _hoisted_7, [_createElementVNode("span", null, _toDisplayString((customer.name || '?').charAt(0)), 1)]), _createElementVNode("span", _hoisted_8, _toDisplayString(customer.name), 1), _createElementVNode("button", {
            type: "button",
            class: "customer-chip-close",
            onClick: _withModifiers($event => onCustomerClick(customer), ["stop"]),
            "aria-label": "移除"
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2.5",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_9)], 8, _hoisted_6);
        }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
          modelValue: queryForm.keyword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryForm.keyword = $event),
          class: "customer-search-input",
          placeholder: "搜索客户姓名、手机号或企业名称",
          clearable: "",
          onKeyup: _withKeys(handleSearch, ["enter"]),
          onClear: handleSearch
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Search))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("button", {
          type: "button",
          class: "btn-primary customer-search-button",
          onClick: handleSearch
        }, "查询")]), _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          ref_key: "scrollbarRef",
          ref: scrollbarRef,
          tag: "div",
          class: "customer-list",
          onScroll: handleScroll
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCustomerList.value, customer => {
            return _openBlock(), _createElementBlock("div", {
              key: customer.id,
              class: _normalizeClass(["customer-row", {
                'is-active': isSelected(customer)
              }]),
              onClick: $event => onCustomerClick(customer)
            }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString((customer.name || '?').charAt(0)), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(customer.name), 1), customer.companyName ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(customer.companyName), 1)) : _createCommentVNode("", true), customer.phone || customer.customerNo ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(customer.phone || customer.customerNo), 1)) : _createCommentVNode("", true)])]), _createElementVNode("span", {
              class: _normalizeClass(["customer-check", {
                'is-checked': isSelected(customer)
              }])
            }, [isSelected(customer) ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[5] || (_cache[5] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "3",
              d: "M5 13l4 4L19 7"
            }, null, -1)]))])) : _createCommentVNode("", true)], 2)], 10, _hoisted_11);
          }), 128)), loading.value && customerList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, "加载中...")) : !hasMore.value && customerList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, "已加载全部")) : !loading.value && customerList.value.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 2,
            description: "暂无客户",
            "image-size": 64
          })) : !loading.value && customerList.value.length > 0 && visibleCustomerList.value.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 3,
            description: "当前列表无匹配客户",
            "image-size": 64
          })) : _createCommentVNode("", true)]),
          _: 1
        })), [[_directive_loading, loading.value && customerList.value.length === 0]])])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};